import type { IconData } from '@stacksjs/iconify-core'

export const check: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9.84 17.08a1 1 0 0 1-.707-.293l-3.84-3.84a1 1 0 1 1 1.414-1.414l3.133 3.133l7.453-7.453a1 1 0 0 1 1.414 1.414l-8.16 8.16a1 1 0 0 1-.707.293\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default check
